import { relative } from 'node:path';
import type { PluginOption } from 'vite';
import { normalizePath } from '@wix/fs-utils';
import { outdent } from 'outdent';

// https://github.com/withastro/astro/blob/e0c4460c5b6cc0c19b705d81820809aef0544100/packages/astro/src/content/utils.ts#L748-L763
const contentCollectionFilePaths = [
  'content.config.mjs',
  'content.config.js',
  'content.config.mts',
  'content.config.ts',
  'content/config.mjs',
  'content/config.js',
  'content/config.mts',
  'content/config.ts',
];

const setupContextualClientUrl = new URL(
  '../build-runtime/runtime/backend/setupContextualClient.js',
  import.meta.url
);

export function setupContentCollectionContext(srcDir: string): PluginOption {
  return {
    name: 'setup-content-collection-context',
    applyToEnvironment(environment) {
      return environment.name === 'ssr';
    },
    transform(code, id) {
      const relativeId = relative(srcDir, id);

      const isContentCollectionFile =
        contentCollectionFilePaths.includes(relativeId);

      if (isContentCollectionFile) {
        return outdent`
          import '${normalizePath(setupContextualClientUrl)}';

          ${code}
        `;
      }

      return null;
    },
  };
}
